<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg519"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs523"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath533"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path531" /></clipPath></defs><g
     id="g525"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g527"><g
         id="g529"
         clip-path="url(#clipPath533)"><g
           id="g535"
           transform="translate(34.4058,166.082)"><path
             d="m 0,0 c -14.485,-22.124 -23.244,-49.064 -24.406,-81.018 52.554,-18.129 111.74,-28.158 171.607,-30.085 M 138.924,76.23 C 109.869,72.491 82.827,64.616 59.442,52.407"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path537" /></g><g
           id="g539"
           transform="translate(173.3574,242.3125)"><path
             d="M 0,0 16.498,-44.956 H 32.796 49.095 L 65.621,0.057"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path541" /></g><g
           id="g543"
           transform="translate(313.9819,375.9072)"><path
             d="m 0,0 v -40.679 c 0,-32.124 -19.219,-60.876 -46.147,-78.836 -18.34,-12.238 -40.252,-19.462 -62.135,-19.321 -54.424,0.341 -108.281,44.419 -108.281,98.157 V 0"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path545" /></g><g
           id="g547"
           transform="translate(313.9819,375.9072)"><path
             d="M 0,0 C 14.597,165.209 -216.563,150.705 -216.563,24.73 V 0 c 0,0 39.911,-5.071 39.486,34.929 C -156.64,14.391 -128.492,0 -85.889,0 Z"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path549" /></g><g
           id="g551"
           transform="translate(313.5566,327.127)"><path
             d="M 0,0 C 23.498,0.85 37.161,29.603 26.135,48.809 L 0.425,48.78"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path553" /></g><g
           id="g555"
           transform="translate(206.1538,54.6401)"><path
             d="M 0,0 C 8.192,-0.028 16.355,0.085 24.547,0.339 L 37.02,34.957 16.298,142.716 H 0 -16.298 L -37.02,34.957 -24.547,0.339 C -16.355,0.085 -8.192,-0.028 0,0 Z"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path557" /></g><g
           id="g559"
           transform="translate(68.8179,69.0869)"><path
             d="M 0,0 V 47.478"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path561" /></g><g
           id="g563"
           transform="translate(97.8159,327.0986)"><path
             d="M 0,0 C -23.471,0.878 -36.027,29.631 -25.001,48.809 H -0.397"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path565" /></g><g
           id="g567"
           transform="translate(310.3535,110.2759)"><path
             d="m 0,0 c 0,-36.43 20.324,-68.1 50.285,-84.275 13.549,-7.338 29.055,-11.501 45.524,-11.501 52.922,0 95.837,42.888 95.837,95.776 0,38.243 -22.45,71.273 -54.906,86.599 C 124.325,92.463 110.464,95.75 95.809,95.75 42.887,95.75 0,52.861 0,0 Z"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path569" /></g><g
           id="g571"
           transform="translate(322.0312,64.4419)"><path
             d="m 0,0 c -29.734,-5.326 -60.433,-8.47 -91.33,-9.462 m 8.277,187.389 C -39.202,172.29 2.551,155.237 32.91,126.739"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path573" /></g><g
           id="g575"
           transform="translate(59.6904,195.2314)"><path
             d="M 0,0 0.17,0.113"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path577" /></g><g
           id="g579"
           transform="translate(440.0923,93.9873)"><path
             d="m 0,0 c 0,-8.385 -2.409,-15.099 -7.256,-20.141 -4.819,-5.043 -10.687,-8.385 -17.575,-10 v -9.49 -0.821 c 0,-5.24 -4.45,-9.49 -9.666,-9.49 -5.215,0 -9.496,4.25 -9.496,9.49 v 10.226 c -4.28,0.991 -8.164,2.578 -11.622,4.76 -3.543,2.266 -6.009,4.248 -7.426,5.976 l -2.069,2.72 c -8.788,11.473 5.668,23.71 14.088,14.873 1.02,-1.048 2.097,-2.352 3.344,-3.711 3.515,-3.91 8.675,-4.533 12.869,-4.533 7.937,0 11.934,3.258 11.934,9.829 0,2.352 -1.531,4.165 -4.536,5.468 -3.005,1.275 -6.661,2.436 -10.941,3.456 -4.309,1.02 -8.618,2.408 -12.897,4.108 -4.309,1.727 -7.965,4.674 -10.97,8.867 -3.005,4.192 -4.507,9.518 -4.507,15.948 0,6.459 2.069,12.209 6.123,17.394 3.997,5.127 9.779,8.611 16.781,9.971 v 2.181 10.821 c 0,5.212 4.28,9.491 9.495,9.491 5.244,0 9.496,-4.279 9.496,-9.491 v -3.994 -9.15 c 3.004,-0.652 5.754,-1.558 8.221,-2.748 2.494,-1.161 4.195,-2.124 5.159,-2.889 l 1.473,-1.275 c 12.472,-9.348 0.425,-25.92 -10.346,-16.855 -7.285,6.119 -23.839,7.479 -23.839,-3.767 0,-2.381 1.106,-4.278 3.288,-5.724 2.211,-1.443 4.933,-2.436 8.164,-2.917 3.203,-0.482 6.747,-1.274 10.63,-2.407 3.855,-1.134 7.426,-2.436 10.63,-3.938 3.231,-1.501 5.952,-4.165 8.163,-7.989 C -1.105,10.454 0,5.694 0,0"
             style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path581" /></g></g></g></g></svg>
</template>
